import { useEffect } from 'react';

const ExternalRedirect = ({ url }) => {
  useEffect(() => {
    // Redirect to external URL
    window.location.href = url;
  }, [url]);

  // Show a loading message while redirecting
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'Arial, sans-serif',
      fontSize: '18px',
      color: '#666'
    }}>
      Redirecting to Yesod.us...
    </div>
  );
};

export default ExternalRedirect;
